import { STALE_BUNDLE_RELOAD_MARKER, isStaleBundleError, shouldReloadForStaleBundle } from './staleBundleError';
const browserRecoveryIo = ()=>({
        readMarker: ()=>{
            var _ref;
            var _window_sessionStorage;
            return (_ref = (_window_sessionStorage = window.sessionStorage) === null || _window_sessionStorage === void 0 ? void 0 : _window_sessionStorage.getItem(STALE_BUNDLE_RELOAD_MARKER)) !== null && _ref !== void 0 ? _ref : null;
        },
        writeMarker: ()=>{
            var _window_sessionStorage;
            return (_window_sessionStorage = window.sessionStorage) === null || _window_sessionStorage === void 0 ? void 0 : _window_sessionStorage.setItem(STALE_BUNDLE_RELOAD_MARKER, '1');
        },
        reload: ()=>window.location.reload()
    });
export const boundaryErrorMessage = (error)=>isStaleBundleError(error) ? 'Stale bundle reload did not recover the chunk' : 'ErrorBoundaryPage caught an error';
export const recoverFromStaleBundle = function recoverFromStaleBundle(error) {
    let io = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : browserRecoveryIo();
    if (!shouldReloadForStaleBundle(error, io.readMarker() != null)) return false;
    io.writeMarker();
    io.reload();
    return true;
};
